import React from 'react';
import { SidebarMenuCaption } from './SidebarMenuCaption';
import { SidebarMenuOption } from './SidebarMenuOption';
import { useSelector } from 'react-redux';

export const SidebarMenu = () => {

    const { menu } = useSelector(state => state.ui);

    if(!menu || menu.length === 0) {
        return null;
    }

    return (
        <div className="navbar-content">
            {
                menu.map(menu => (
                    <ul key={menu.label} className="nxl-navbar">
                        {
                            menu.label && <SidebarMenuCaption label={menu.label} />
                        }
                        {
                           menu.children && menu.children.map(menuOption => ( <SidebarMenuOption key={menuOption.label} title={menuOption.label} icon={menuOption.icon} options={menuOption.children} link={menuOption.link} /> ))
                        }
                    </ul>
                ))
            }
        </div>
    );
};
